import { KEY_CODE_MAP, FOCUSABLE_ELEMENT_SELECTORS } from '@utils/keyboard-helpers'

export default {
  props: {
    outerActivator: {
      type: HTMLElement
    }
  },
  data: () => ({
    focusableElements: null,
    innerActivator: null
  }),
  computed: {
    firstFocusableEl() {
      return this.focusableElements && this.focusableElements[0]
    },
    lastFocusableEl() {
      return this.focusableElements && this.focusableElements[this.focusableElements.length - 1]
    },
    activatorEl() {
      return this.outerActivator || this.innerActivator
    }
  },
  mounted() {
    this.bindTabTrapEvents()
    this.$nextTick(() => {
      this.getFocusableElements()
      if (this.firstFocusableEl && !this.noInitialFocus) {
        this.firstFocusableEl.focus()
      }
    })
  },
  updated() {
    this.$nextTick(() => {
      this.getFocusableElements()
    })
  },
  beforeDestroy() {
    this.unbindTabTrapEvents()
    if (this.activatorEl) {
      this.activatorEl.focus()
    }
  },
  methods: {
    getFocusableElements() {
      this.focusableElements = []
      if (this.$el && typeof this.$el.querySelectorAll === 'function') {
        const elements = Array.from(this.$el.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS))
        const radioGroups = new Map()

        elements.forEach((el) => {
          const isActivator = this.activatorEl && el.isEqualNode(this.activatorEl)

          // Special handling for radio buttons:
          // Radio buttons with the same 'name' attribute form a group and should be treated
          // as a single focusable unit for tab navigation. We only add the first radio button
          // of each group to the focusable elements list, while arrow key navigation within
          // the group is handled natively by the browser.
          if (!isActivator) {
            if (el.type === 'radio' && el.name) {
              if (!radioGroups.has(el.name)) {
                radioGroups.set(el.name, [])
                this.focusableElements.push(el)
              }
              radioGroups.get(el.name).push(el)
            } else {
              this.focusableElements.push(el)
            }
          }
        })
      }
    },
    bindTabTrapEvents() {
      this.$el.addEventListener('keydown', this.onKeyEvent)
    },
    unbindTabTrapEvents() {
      this.$el.removeEventListener('keydown', this.onKeyEvent)
    },
    onKeyEvent(e) {
      const { activeElement } = document
      const { lastFocusableEl, firstFocusableEl } = this

      if (this.isInactive) return
      if (e.keyCode === KEY_CODE_MAP.TAB) {
        if (e.shiftKey && activeElement.isSameNode(firstFocusableEl)) {
          e.preventDefault()
          e.stopPropagation()
          lastFocusableEl.focus()
        } else if (!e.shiftKey && activeElement.isSameNode(lastFocusableEl)) {
          e.preventDefault()
          e.stopPropagation()
          firstFocusableEl.focus()
        }
      } else if (e.keyCode === KEY_CODE_MAP.ESCAPE) {
        this.closeModal()
      }
    }
  }
}
